import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { api } from "../../../api";
import { Formik, Form, FieldArray } from "formik";
import DynamicAddOrderhistory from "../../addOrderHistory/addOrderHistory";
import { AddOrderSchema } from "../../../validation/ValidationSchema";
import Moment from "moment";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
import ButtonContained from "../../button";
import { toast } from "react-toastify";
import { decimalTo } from "../../../utils/utils";

export default function OrderInfo() {
  const token = useSelector((state) => state.auth.token);
  // eslint-disable-next-line
  const [orderId, setOrderId] = useState(useParams().id);
  const [order, setOrder] = useState([]);
  const [orderHistoryStyle, setOrderHistoryStyle] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const navigate = useNavigate();
  const { userType: role } = useSelector((state) => state.auth.user);
  const { id: orderid } = useParams();
  const statusList = [
    {
      label: "Completed",
      id: 1,
    },
    {
      label: "Cancelled",
      id: 3,
    },
  ];

  useEffect(() => {
    api.orders.viewOrders({ orderId: orderId }, token).then((result) => {
      if (result.success === true) {
        setOrderStatus(result.data.status);
        if (result.data.status === "Cancelled" || role === 3) {
          setOrderHistoryStyle("col-12");
        } else {
          setOrderHistoryStyle("col-6");
        }
        setOrder(result.data);
      } else {
        toast.error(result.message);
      }
    });
  }, [orderId, role, token]);

  const downLoadExcel = () => {
    api.orders
      .exportOrdersDetails(
        {
          orderId: orderid,
        },
        token
      )
      .then((res) => {
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        // eslint-disable-next-line
        const fileExtension = ".xlsx";

        const ws = XLSX.utils.json_to_sheet(res.data);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "OrderDetails.xlsx");
      })
      .catch((err) => console.log(err));
  };

  // Function to prepare CSV data for devco orders
  const prepareCSVData = () => {
    const csvData = [];

    // Add headers
    csvData.push(["Product Name", "Product Key"]);

    // Process each order item
    if (order.ordersItems) {
      order.ordersItems.forEach((item, itemIndex) => {
        const productName = item.productName || item.product?.productName || "";

        if (item.productKey) {
          // Split comma-separated keys
          const keys = item.productKey
            .split(",")
            .map((key) => key.trim())
            .filter((key) => key);

          keys.forEach((key, keyIndex) => {
            csvData.push([productName, key]);
          });
        } else {
          // If no product key, still add a row
          csvData.push([productName, "No Key Available"]);
        }
      });
    }

    return csvData;
  };

  // eslint-disable-next-line
  function handleReprocess() {
    api.orders.reprocessOrder({ orderId: orderId }, token).then((result) => {
      if (result.success === true) {
        setOrder(result.data);
      } else {
        toast.error(result.message);
      }
    });
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="box-row">
            <div className="table-head">
              <h1 className="sec-header">ORDER DETAILS</h1>
              {order.isDevco ? (
                <CSVLink
                  data={prepareCSVData()}
                  filename={`${order.orderId}.csv`}
                  className="btn btn-primary ml-2 px-4"
                  style={{
                    position: "absolute",
                    top: "15px",
                    right: "15px",
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                >
                  Export Keys
                </CSVLink>
              ) : (
                <button
                  className="btn btn-primary ml-2 px-4"
                  style={{
                    position: "absolute",
                    top: "15px",
                    right: "15px",
                    cursor: "pointer",
                  }}
                  onClick={downLoadExcel}
                >
                  Export Keys
                </button>
              )}

              {/* <i
                className="bx bx-menu bold dropdown-toggle p-2"
                style={{
                  position: "absolute",
                  top: "15px",
                  right: "15px",
                  cursor: "pointer",
                }}
                data-toggle="dropdown"
              ></i>
              <div
                className="dropdown-menu dropdown-list1"
                style={{ cursor: "pointer" }}
              >
                <span className="dropdown-item" onClick={downLoadExcel}>
                  <i className="bx bxs-file-pdf mr-2"></i>Export Keys
                </span>
              </div> */}
            </div>
            <div className="card border mb-3" style={{ border: "1px solid" }}>
              <div
                className="card-header card-header-title"
                style={{ borderBottom: "1px solid #dee2e6" }}
              >
                <div className="detail-id float-left">
                  Order ID : <b>{order.orderId}</b>
                </div>
                <div className="detail-id float-right">
                  Order Status : <b>{order.status}</b>
                </div>
              </div>

              <div className="card-body text-info">
                <div className="row">
                  <div className="col-md-6">
                    <div className="billing text-left">
                      <h6>
                        <b>Billing Address</b>
                      </h6>
                      <p>{order.orderAddress}</p>
                      {/* <h3 className="mt-4">Payment Method:</h3>
                                        <p>Visa ending **** 4242</p> */}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="billing  text-right">
                      <h6>
                        <b>Order Date</b>
                      </h6>
                      <p>{order.orderDate}</p>
                      {/* <h6><b>Order Status:</b></h6>
                                        <p>Pending</p> */}
                    </div>
                  </div>
                </div>

                <div className="card-body p-0 gatepass-saveoutput">
                  <div className="reports order-summary">
                    <h6 className="mt-3">
                      <b>Order Summary</b>
                    </h6>
                    <table
                      id="product-table "
                      className="table table-responsive table-bordered mt-4"
                    >
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Items</th>
                          <th>Quantity</th>
                          <th>MRP</th>
                          <th>D.MRP</th>
                          <th>Amount</th>
                          <th>Margin</th>
                          <th>Net Amount</th>
                          {role !== 4 && <th></th>}
                          {/* <th>Action</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {order.ordersItems ? (
                          <React.Fragment>
                            {order.ordersItems.map((row, index) => {
                              const prodName = row.productName
                                ? row.productName
                                : row.product.productName;
                              return (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>{index + 1}</td>
                                    <td>{prodName}</td>
                                    <td>{row.quantity}</td>
                                    <td>
                                      {decimalTo(row.productMrp).toFixed(2)}
                                    </td>
                                    <td>{decimalTo(row.disMrp).toFixed(2)}</td>
                                    <td>{decimalTo(row.amount).toFixed(2)}</td>
                                    <td>
                                      {row.margin
                                        ? decimalTo(row.margin).toFixed(2)
                                        : ""}
                                    </td>
                                    <td>
                                      {row.net_amount !== null &&
                                      row.net_amount !== undefined ? (
                                        <span>
                                          {row.net_amount
                                            ? decimalTo(row.net_amount).toFixed(
                                                2
                                              )
                                            : ""}
                                        </span>
                                      ) : (
                                        <span> {"-"}</span>
                                      )}
                                    </td>
                                    {role !== 4 && (
                                      <td
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <button
                                          style={{
                                            width: "auto",
                                            border: "none",
                                            borderRadius: "50%",
                                          }}
                                          type="button"
                                          className="btn btn-primary"
                                          data-toggle="collapse"
                                          data-target={`#accordion${index + 1}`}
                                          disabled={row.productKey === ""}
                                          title={
                                            row.productKey === ""
                                              ? "No Prodcuct Keys"
                                              : "View Product Keys"
                                          }
                                        >
                                          {" "}
                                          View{" "}
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                  {role !== 4 && (
                                    <tr>
                                      <td
                                        colSpan="7"
                                        id={`accordion${index + 1}`}
                                        className="collapse"
                                      >
                                        <label>
                                          {" "}
                                          <b> Product Key : </b> &nbsp;{" "}
                                          {row.productKey}{" "}
                                        </label>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </React.Fragment>
                        ) : null}
                      </tbody>
                    </table>
                    {order ? (
                      <div className="float-right text-right ml-4 mr-4">
                        <div className="row table-total">
                          <div className="float-right text-right total-ans pr-2">
                            <h6>
                              <b>Total Order Amount:</b>
                            </h6>
                          </div>
                          <div>
                            <h6>
                              {order.orderAmount ? (
                                <b>
                                  {order.orderAmount
                                    ? decimalTo(order.orderAmount).toFixed(2)
                                    : ""}
                                </b>
                              ) : null}
                            </h6>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="col-md-9">
                      <div className="comment text-left">
                        <h6>
                          <b>Comment</b>
                        </h6>
                        <p>{order?.comment || ""}</p>
                      </div>
                    </div>

                    {/* <button type="submit" className="btn mt-3 submit-btn float-right">Place Order</button> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              {order.status === "Completed" &&
              order.status !== "Cancelled" &&
              role !== 3 ? (
                <div className="col-6">
                  <div
                    className="card border mb-3"
                    style={{ border: "1px solid", height: "100%" }}
                  >
                    <div className="card-body text-info">
                      <div className="card-body p-0 gatepass-saveoutput">
                        <div className="reports order-summary">
                          <h6 className="mt-3">
                            <b>Add Order History</b>
                          </h6>
                          <Formik
                            validationSchema={AddOrderSchema}
                            initialValues={{
                              productAccess: [
                                {
                                  quantity: "",
                                  productName: "",
                                },
                              ],
                            }}
                            onSubmit={(Values, { resetForm }) => {
                              let body;
                              if (orderStatus === "Completed") {
                                body = {
                                  orderId: orderId,
                                  status: orderStatus
                                    ? 1
                                    : parseInt(
                                        Values.productAccess[0].productName.id
                                      ),
                                  comments: Values.productAccess[0].quantity,
                                };
                              } else {
                                body = {
                                  orderId: orderId,
                                  status: parseInt(
                                    Values.productAccess[0].productName.id
                                  ),
                                  comments: Values.productAccess[0].quantity,
                                };
                              }

                              api.orders
                                .reprocessOrder(body, token)
                                .then((result) => {
                                  if (result.success === true) {
                                    setOrder(result.data);
                                    toast.success(result.message);
                                    navigate("/orders");
                                  } else {
                                    toast.error(result.message);
                                  }
                                });
                            }}
                          >
                            {({
                              handleSubmit,
                              handleChange,
                              handleBlur,
                              values,
                              touched,
                              isValid,
                              errors,
                              isSubmitting,
                              setFieldValue,
                            }) => {
                              return (
                                <div className="container-fluid">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="box-row">
                                        <div className="card card-table">
                                          <div className="card-header card-header-title"></div>
                                          <div className="card-body gatepass-saveoutput">
                                            <div className="reports">
                                              <Form onSubmit={handleSubmit}>
                                                <FieldArray
                                                  name="productAccess"
                                                  render={(helper) => {
                                                    return (
                                                      <div>
                                                        {values.productAccess &&
                                                          values.productAccess
                                                            .length > 0 &&
                                                          values.productAccess.map(
                                                            (
                                                              productAccess,
                                                              index
                                                            ) => {
                                                              return (
                                                                <div>
                                                                  {orderStatus && (
                                                                    <DynamicAddOrderhistory
                                                                      key={
                                                                        index
                                                                      }
                                                                      index={
                                                                        index
                                                                      }
                                                                      values={
                                                                        values
                                                                      }
                                                                      orderStatus={
                                                                        orderStatus
                                                                      }
                                                                      handleChange={
                                                                        handleChange
                                                                      }
                                                                      handleRemoveProduct={() =>
                                                                        helper.remove(
                                                                          index
                                                                        )
                                                                      }
                                                                      setFieldValue={
                                                                        setFieldValue
                                                                      }
                                                                      touched={
                                                                        touched
                                                                      }
                                                                      errors={
                                                                        errors
                                                                      }
                                                                      products={
                                                                        statusList
                                                                      }
                                                                      isSubmitting={
                                                                        isSubmitting
                                                                      }
                                                                    />
                                                                  )}
                                                                </div>
                                                              );
                                                            }
                                                          )}
                                                      </div>
                                                    );
                                                  }}
                                                ></FieldArray>

                                                <ButtonContained
                                                  buttonName="Reprocess"
                                                  disabled={
                                                    !values.productAccess[0]
                                                      .quantity
                                                      ? true
                                                      : isSubmitting
                                                  }
                                                />
                                              </Form>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }}
                          </Formik>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {order.reprocessHistory && order.reprocessHistory.length > 0 ? (
                <div className={orderHistoryStyle}>
                  <div
                    className="card border mb-3 card-order"
                    style={{
                      border: "1px solid",
                      overflowY: "scroll",
                      height: "100%",
                      maxHeight: "100%",
                    }}
                  >
                    <div
                      className="card-body text-info"
                      style={
                        {
                          // overflow: 'scroll',
                          // height: ' 503px'
                        }
                      }
                    >
                      <div className="card-body p-0 gatepass-saveoutput">
                        <div className="reports order-summary">
                          <h6 className="mt-3">
                            <b>Order History</b>
                          </h6>
                          {order.reprocessHistory ? (
                            <div>
                              {order.reprocessHistory.map((row, index) => (
                                <form className="shadow-sm p-3 mb-2 bg-white rounded">
                                  <div className="form-row">
                                    <label
                                      className="col-sm-3 p-0 col-form-label"
                                      style={{ lineHeight: 2 }}
                                    >
                                      Order Status:
                                    </label>
                                    <div className="form-group m-0 col-md-9">
                                      <label className="col-form-label p-0">
                                        {row.previousStatus === 2 && (
                                          <label>Processing</label>
                                        )}
                                        {row.previousStatus === 1 && (
                                          <label>Completed</label>
                                        )}
                                        {row.previousStatus === 3 && (
                                          <label>Cancelled</label>
                                        )}
                                      </label>
                                    </div>
                                  </div>

                                  <div className="form-row">
                                    <label
                                      className="col-sm-3 col-form-label p-0"
                                      style={{ lineHeight: 2 }}
                                    >
                                      Comment:
                                    </label>
                                    <div className="form-group m-0 col-md-9">
                                      <label className="col-form-label p-0">
                                        {row.comments}
                                      </label>
                                    </div>
                                  </div>
                                  <div className="form-row">
                                    <label
                                      className="col-sm-3 p-0 col-form-label"
                                      style={{ lineHeight: 2 }}
                                    >
                                      Date:
                                    </label>
                                    <div className="form-group m-0 col-md-9">
                                      <label className="col-form-label p-0">
                                        {Moment(row.createdAt).format(
                                          "DD-MM-YYYY"
                                        )}
                                      </label>
                                    </div>
                                  </div>
                                </form>
                              ))}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
